import {Children, ClassComponent, Vnode} from 'mithril';
import Embed from '../models/Embed';
import labelIsSameAsLink from '../utils/labelIsSameAsLink';
import BlockEmbed from './BlockEmbed';
import InlineEmbed from './InlineEmbed';
import {RichImageAttrs} from './RichImage';

export interface RichEmbedAttrs {
    layout?: string,
    style?: string,
    withoutOpengraph?: boolean
    labelHtml: string
    childImage?: RichImageAttrs
    embed: Embed
    canDisable: boolean
    disable: () => Promise<any>
}

export default class RichEmbed implements ClassComponent<RichEmbedAttrs> {
    view(vnode: Vnode<RichEmbedAttrs, this>): Children {
        if (this.shouldUseInlineMode(vnode)) {
            return m(InlineEmbed, vnode.attrs);
        }

        return m(BlockEmbed, vnode.attrs);
    }

    shouldUseInlineMode(vnode: Vnode<RichEmbedAttrs, this>): boolean {
        // This would probably also match the label different from link below but this way it's explicit
        if (vnode.attrs.childImage) {
            return true;
        }

        // If inline mode was enabled globally
        if (vnode.attrs.layout === 'inline') {
            return true;
        }

        // If the link has a custom label (different from URL)
        if (vnode.attrs.labelHtml && !labelIsSameAsLink(vnode.attrs.labelHtml, vnode.attrs.embed.id()!)) {
            return true;
        }

        // If no opengraph data was found
        if (!vnode.attrs.embed.hasContent(vnode.attrs.withoutOpengraph)) {
            return true;
        }

        return false;
    }
}
